import { render, staticRenderFns } from "./IconPoiCourthouse.vue?vue&type=template&id=e25d33c8&"
import script from "./IconPoiCourthouse.vue?vue&type=script&lang=js&"
export * from "./IconPoiCourthouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports